module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "41",
      "height": "41",
      "viewBox": "0 0 41 41",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20.5",
      "cy": "20.5",
      "r": "20.5",
      "fill": "#E8E7E5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21.5 27.9996H13V9.5H23L26.5 13.1875V23.4996C27 23.6662 28.1 23.9996 28.5 23.9996C28.9 23.9996 29.6667 25.3329 30 25.9996V27.9996L28.5 30.4996L26.5 30.9996H24.5L22.5 29.4996L21.5 27.9996Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.5616 23.6865H16.2655C15.8777 23.6865 15.5869 24.0016 15.5869 24.3651C15.5869 24.7287 15.902 25.0437 16.2655 25.0437H19.5616C19.9494 25.0437 20.2402 24.7287 20.2402 24.3651C20.2402 24.0016 19.9494 23.6865 19.5616 23.6865Z",
      "fill": "black",
      "stroke": "#E8E7E5",
      "stroke-width": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.2655 21.6512H23.1243C23.5121 21.6512 23.8029 21.3361 23.8029 20.9726C23.8029 20.5848 23.4879 20.2939 23.1243 20.2939H16.2655C15.8777 20.2939 15.5869 20.609 15.5869 20.9726C15.5869 21.3361 15.902 21.6512 16.2655 21.6512Z",
      "fill": "black",
      "stroke": "#E8E7E5",
      "stroke-width": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.2655 18.2098H23.1243C23.5121 18.2098 23.8029 17.8947 23.8029 17.5311C23.8029 17.1434 23.4879 16.8525 23.1243 16.8525H16.2655C15.8777 16.8525 15.5869 17.1676 15.5869 17.5311C15.5869 17.8947 15.902 18.2098 16.2655 18.2098Z",
      "fill": "black",
      "stroke": "#E8E7E5",
      "stroke-width": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.2655 14.7684H19.0769C19.4647 14.7684 19.7555 14.4533 19.7555 14.0897C19.7555 13.702 19.4404 13.4111 19.0769 13.4111H16.2655C15.8777 13.4111 15.5869 13.7262 15.5869 14.0897C15.5869 14.4533 15.902 14.7684 16.2655 14.7684Z",
      "fill": "black",
      "stroke": "#E8E7E5",
      "stroke-width": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.4384 22.8388V13.3625C27.4384 13.1928 27.3656 12.9989 27.2445 12.8778L23.5606 9.19389C23.4394 9.07271 23.2455 9 23.0759 9H12.6786C12.2908 9 12 9.31507 12 9.67861V28.1465C12 28.5342 12.3151 28.8251 12.6786 28.8251H21.137C21.7914 30.667 23.5606 32 25.6207 32C28.2381 32 30.3952 29.8672 30.3952 27.2255C30.3952 25.2624 29.1591 23.5659 27.4384 22.8388ZM23.0516 10.6481L25.7903 13.3867H23.0516V10.6481ZM13.3572 27.4679V10.3815H21.6702V14.0896C21.6702 14.4773 21.9852 14.7682 22.3488 14.7682H26.0327V22.4995C25.8872 22.4752 25.7418 22.4752 25.5964 22.4752C22.9789 22.4752 20.8219 24.608 20.8219 27.2497C20.8219 27.3224 20.8219 27.3952 20.8219 27.4679H13.3572ZM25.6207 30.6428C23.7545 30.6428 22.2276 29.1159 22.2276 27.2497C22.2276 25.3836 23.7545 23.8567 25.6207 23.8567C27.4868 23.8567 29.0137 25.3836 29.0137 27.2497C29.0137 29.1159 27.4868 30.6428 25.6207 30.6428Z",
      "fill": "black",
      "stroke": "#E8E7E5",
      "stroke-width": "0.3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.5417 25.9167L25.0633 27.3951L24.5786 26.9104C24.312 26.6438 23.8757 26.6438 23.6091 26.9104C23.3425 27.177 23.3425 27.6133 23.6091 27.8799L24.6028 28.8735C24.7482 29.019 24.9179 29.0674 25.0875 29.0674C25.2572 29.0674 25.4511 28.9947 25.5722 28.8735L27.5596 26.8862C27.8262 26.6196 27.8262 26.1833 27.5596 25.9167C27.2445 25.6501 26.8083 25.6501 26.5417 25.9167Z",
      "fill": "black",
      "stroke": "#E8E7E5",
      "stroke-width": "0.3"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b99c85c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/progressSideBar/icons/TermsIcon.vue
// module id = 643
// module chunks = 0